<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <!-- <banner :child-data="fdata"></banner> -->
    <div style="height:650px;overflow:hidden"
         class="mainTop"
         :style="{ height: Mobile + 'px'}">
      <img v-if="!showMobile"
           src="productImg/software.jpg"
           alt=""
           class="mobile"
           style="height:100%;position: relative;"
           :style="{ height: Mobile + 'px'}">
      <img v-if="showMobile"
           src="productImg/softwareMobile.jpg"
           alt=""
           class="mobile"
           style="width:100% !important;height:100%;position: relative;"
           :style="{ height: Mobile + 'px'}">
    </div>
    <!-- <div class="part_2" style="text-align: center; height: 840px; background: #f7f7f7;background: url(productImg/2.jpg)center; height: 979px;">
        <h2 style="color: #fff; font-size: 48px; padding-top: 130px; margin-top: 0;">高能效NPU的AI芯片</h2>
        <h4 style="width: 1150px;margin: 0 auto;font-size: 18px; color: #fff; margin-top: 50px; margin-bottom: 80px;line-height: 1.5;">
            RK1808 AI芯片CPU采用双核Cortex-A35架构，最高频率1.6GHz，VPU支持1080P常规视频格式的编码和解码，支持摄像头视频信号输入并内置了ISP。提供多种存储配置选择，用户仅需扩展功能底板即可快速实现项目研产
        </h4>
    </div> -->
    <div id="product-main"
         class="container">
      <div class="ai-sec">
        <div class="container">
          <div class="company-develop"
               data-ani>
            <div class="info-title">
              <span class="line"></span>
              <span v-if="menu != 'all'"
                    class="title-text">{{$t(detail_h1)}}</span>
              <span v-if="menu == 'all'"
                    class="title-text">{{$t('homenavSdk0')}}</span>
              <span class="line"></span>
            </div>
          </div>
          <el-tabs style=""
                   class="myProducttab">
            <el-tab-pane :label="$t('detail_label0')">
              <div class="detail-p"
                   id="detail-p">
                <p>{{$t('SdkDescription')}}
                </p>
                <!-- <p class="ptitle">强大算力</p>
                <p>1、人工智能主控芯片，内置独立5TOPS NPU</p>
                <p>2、4核A73+2核A53大小核设计，主频高达2.2 GHz, 峰值速度和低功耗兼顾</p>

                <p class="ptitle">开放算力</p>
                <p>1、支持主流网络训练模型实例，无需重新训练网络、模型训练工具即转即用</p>
                <p>2、支持Caffe、PyTorch、Tensorflow和Onnx模型的转换。提供8bit量化、16bit量化以及按层设定的混合量化支持</p>

                <p class="ptitle">内置算法</p>
                <p>1、人体结构化算法：人脸检测、人脸识别、性别年龄、帽子眼镜、人体检测、人体关节点、手势识别等</p>
                <p>2、车辆结构化算法：车辆检测、车牌识别、车身颜色等</p>
                <p>3、支持算法定制化开发</p>

                <p class="ptitle">多路多模态</p>
                <p>1、支持4路1080P网络摄像头和USB摄像头实时解码，人、车等多种目标实时检测及识别</p>

                <p class="ptitle">云边融合</p>
                <p>1、支持NeuLink协议接入Neucore公有云平台、及私有云平台部署，支持主流阿里云/AWS等平台</p>

                <p class="ptitle">丰富接口</p>
                <p>1、支持100M/1000M自适应网口</p>
                <p>2、支持MicroSD/Micro SDHC/Micro SDXC卡（64GB/128GB/256GB）本地存储</p>
                <p>3、2路USB2.0，1路MiniUSB接口</p>
                <p>4、支持HDMI显示屏</p>
                <p>5、1路DC12V电源输入，TDP≤5W</p> -->

              </div>
              <div class="ai-advantage bcw"
                   data-ani>
                <div>
                  <!-- <div class="develop-title">
                      <span class="line"></span>
                      <span class="title-text">{{$t('solution0_function')}}</span>
                      <span class="line"></span>
                    </div> -->
                  <span class="ptitle">{{$t('UseSecne')}}</span>
                  <div class="solutionDitails">
                    <b-card-group deck>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/a-03.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('solution0_function0')}}</h3>
                          </div>
                        </div>
                      </b-card>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/a-04.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('solution0_function1')}}</h3>
                          </div>
                        </div>
                      </b-card>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/a-05.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('solution0_function2')}}</h3>
                          </div>
                        </div>
                      </b-card>
                    </b-card-group>

                    <b-card-group deck>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/b-02.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('homenav1CT1')}}</h3>
                          </div>
                        </div>
                      </b-card>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/a-07.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('solution0_function4')}}</h3>
                          </div>
                        </div>
                      </b-card>
                      <b-card>
                        <div class="block mypointer">
                          <div class="pic lazyload-v2 picImg2 over"
                               style="height: auto; background: none;">
                            <div class="lazyload-v2-wrap">
                              <img src="img/Solution/b-10.jpg"
                                   alt=""
                                   class="bg100">
                            </div>
                          </div>
                          <div class="poL">
                            <h3>{{$t('homenav1SPT0')}}</h3>
                          </div>
                        </div>
                      </b-card>
                    </b-card-group>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('detail_label1')">
              <div class="company-develop"
                   data-ani>
                <!-- <div class="info-title">
                  <span class="line"></span>
                  <span class="title-text">技术参数</span>
                  <span class="line"></span>
                </div> -->
                <div class="develop-main mobileScroll">
                  <table class="table table-hover"
                         id="table3"
                         v-if="menu == 'linux' || menu == 'all'">
                    <thead>
                      <tr>
                        <th width></th>
                        <th>{{$t('Product0secT1')}}</th>
                        <th>{{$t('Product0secT2')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="4">{{$t('sdktableTd0')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd1')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd2')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd3')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd4')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd5')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd6')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd7')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd8')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd9')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd10')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd11')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd12')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd13')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd14')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd15')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd16')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd17')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd18')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd19')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd20')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd21')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd22')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd23')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd24')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd24')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd25')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd26')}}</td>
                      </tr>
                      <tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd27')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd28')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd29')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd30')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd31')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd32')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd33')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd34')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd35')}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="table table-hover"
                         id="table3"
                         v-if="menu == 'android'">
                    <thead>
                      <tr>
                        <th width></th>
                        <th>{{$t('Product0secT1')}}</th>
                        <th>{{$t('Product0secT2')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="4">{{$t('sdktableTd0')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd1')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd2')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd3')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd4')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd5')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd6')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd7')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd8')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd9')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd10')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd11')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd12')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd13')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd14')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd15')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd16')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd17')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd18')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd19')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd20')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd21')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd22')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd23')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd24')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd24')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd25')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd26')}}</td>
                      </tr>
                      <tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd27')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd28')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 180px;"
                            rowspan="3">{{$t('sdktableTd29')}}</td>
                        <td class="tal"
                            style="width: 240px;">{{$t('sdktableTd30')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd31')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd32')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd33')}}</td>
                      </tr>
                      <tr>
                        <td style="vertical-align: middle;width: 100px;">{{$t('sdktableTd34')}}</td>
                        <td class="tal"
                            style="">{{$t('sdktableTd35')}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('detail_label2')">
              <div class="detail-p"
                   id="detail-p">
                <p v-if="menu != 'all'"><a :href="a_attr"
                     target="_self">{{$t(detail_h1)}}</a></p>
                <p v-if="menu == 'all'"><a href="https://confluence.neucore.com/display/KB/NeuSDK+Linux"
                     target="_self">{{$t('homenavSdk1')}}</a></p>
                <p v-if="menu == 'all'"><a href="https://confluence.neucore.com/display/KB/NeuSDK+Android"
                     target="_self">{{$t('homenavSdk2')}}</a></p>
              </div>
            </el-tab-pane>
          </el-tabs>
          <!-- <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">产品中心</span>
                <span class="line"></span>
              </div>
              <div class="function">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>核心板 · 模组</span>
                  </div>
                  <el-row :gutter="0">
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :sm="12" :md="6" :lg="5">
                      <el-card shadow="hover" :body-style="{ padding: '8px' }">
                        <img src="http://www.t-firefly.com/upload/portal/20200117/38b3e350f00ed0617a034f404ff80be6.png" class="image">
                        <div style="padding: 14px;">
                          <div class="bottom clearfix">
                            <span class="myH5">Core-1808-JD4</span>
                            <span class="myH6">人工智能核心板</span>
                            <el-button type="text" class="button myBtn">购买</el-button>
                          </div>
                        </div>
                      </el-card>
                    </el-col>
                  </el-row>
                </el-card>

              </div> -->
        </div>
      </div>
    </div>
    <!-- <div>
      <img class="img100" src="img/NeuBoard/1.jpg" alt="">
      <img class="img100" src="img/NeuBoard/2.jpg" alt="">
      <img class="img100" src="img/NeuBoard/3.jpg" alt="">
      <img class="img100" src="img/NeuBoard/4.jpg" alt="">
      <img class="img100" src="img/NeuBoard/5.jpg" alt="">
    </div> -->
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import '../../public/css/font-awesome.min.css'
import '../../public/lib/response_table.css'
import '../../public/lib/response_table.css'
import jQuery from '../../public/js/jquery.min.js'
import '../../public/lib/response_table.js'
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'

export default {
  name: 'product',
  components: {
    topNav,
    banner,
    footerBot
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      showMobile: false,
      Mobile: 650,
      menu: 'linux',
      a_attr: 'https://confluence.neucore.com/display/KB/NeuSDK+Linux',
      a_attr2: 'https://confluence.neucore.com/display/KB/NeuSDK+Android',
      detail_h1: 'homenavSdk1',
      detail_h2: 'homenavSdk2',
      allWord: {
        linux: {
          h1: 'homenavSdk1',
          attr: 'https://confluence.neucore.com/display/KB/NeuSDK+Linux'
        },
        android: {
          h1: 'homenavSdk2',
          attr: 'https://confluence.neucore.com/display/KB/NeuSDK+Android'
        }
      },
      fdata: {
        h1: 'Product',
        menu: '',
        h2: 'AI on device for you all',
        style: {
          background:
            'url(../img/product/cpzx_banner@3x.jpg)  center top 100% no-repeat ',
          backgroundSize: '100% 100%'
        }
      }
    }
  },
  methods: {
    ...mapMutations(['editMenu'])
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (to.query.id) {
        this.menu = to.query.id
        this.detail_h1 = this['allWord'][to.query.id]['h1']
        this.a_attr = this['allWord'][to.query.id]['attr']
        console.log(this.menu)
      } else {
        this.menu = 'linux'
      }
    }
  },
  mounted() {
    console.log(this.$route)
    if (this.$route.query) {
      if (this.$route.query.id) {
        this.menu = this.$route.query.id
        this.detail_h1 = this['allWord'][this.$route.query.id]['h1']
        this.a_attr = this['allWord'][this.$route.query.id]['attr']
      } else {
        this.menu = 'linux'
      }
    }
    if (this.screenWidth < 480 || this.screenWidth === 480) {
      this.showMobile = true
      this.Mobile = window.screen.height
    }
    // jQuery("#table").basictable();
    this.editMenu('product')
    var Expand = (function() {
      var tile = $t('.strips__strip')
      var tileLink = $t('.strips__strip > .strip__content')
      var tileText = tileLink.find('.strip__inner-text')
      var stripClose = $t('.strip__close')
      var expanded = false
      var open = function() {
        var tile = $t(this).parent()
        if (!expanded) {
          tile.addClass('strips__strip--expanded')
          tileText.css(
            'transition',
            'all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)'
          )
          stripClose.addClass('strip__close--show')
          stripClose.css(
            'transition',
            'all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)'
          )
          expanded = true
        }
      }
      var close = function() {
        if (expanded) {
          tile.removeClass('strips__strip--expanded')
          tileText.css(
            'transition',
            'all 0.05s 0 cubic-bezier(0.23, 1, 0.32, 1)'
          )
          stripClose.removeClass('strip__close--show')
          stripClose.css(
            'transition',
            'all 0.2s 0s cubic-bezier(0.23, 1, 0.32, 1)'
          )
          expanded = false
        }
      }
      var bindActions = function() {
        tileLink.on('click', open)
        stripClose.on('click', close)
      }
      var init = function() {
        bindActions()
      }

      return {
        init: init
      }
    })()
    Expand.init()
  }
}
</script>

<style scoped>
blockquote {
  border: none;
}

#navbar-main {
}

#product-main {
  /* padding-bottom: 30px; */
}
.ai-sec {
  padding: 60px 0px;
}
h3 {
  color: #0085cb;
}

#headerwrap {
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#product-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}
@media screen and (max-width: 1366px) {
  .mainTop {
    height: 440px;
  }
}
@media screen and (max-width: 480px) {
  .mainTop {
    height: 650px;
  }
  #product-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }
  .mobile {
    width: auto !important;
    height: 100% !important;
  }
}

#product-main .product-info {
  /* padding: 50px 0px; */
  box-sizing: border-box;
}

#product-main .info-title,
#product-main .develop-title {
  margin-bottom: 10px;
  margin-top: 0px !important;
  /* color: white; */
  border-radius: 20px;
  padding: 10px;
  margin-bottom: 40px;
  /* background: orange; */
  border-radius: 24px;
  padding: 10px 30px;
  color: white;
  text-align: center;
  width: 100%;
}

#product-main .info-title {
  margin-top: 80px;
}
#product-main .info-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

#product-main .info-main img {
  width: 100%;
}

#product-main .info-title .title-text,
#product-main .develop-title .title-text {
  font-size: 30px;
  color: black;
}

.company-develop {
  width: 100%;
  margin: 0 auto;
  padding-top: 0px;
}
.mobileScroll {
  margin-top: 16px;
}
@media screen and (max-width: 480px) {
  .company-develop {
    width: 100%;
    margin: 0 auto;
  }
  .mobileScroll {
    width: 100%;
    overflow: scroll;
  }
}

.company-develop #myTabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.company-develop #myTabs li {
  flex: 1;
  text-align: center;
}

.case-core {
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 413px;
  transition: background-image 0.5s;
  margin-bottom: 60px;
  background-color: #08061e;
}

.case-core-list {
  height: 100%;
  width: 25%;
  float: left;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 100px 35px 0;
  position: relative;
  transition: all 0.5s;
  cursor: pointer;
}

.en .case-core-list {
  padding-top: 50px;
}

.case-core.cell1 .case-core-list {
  width: 100%;
  border-right: none;
}

.case-core.cell2 .case-core-list {
  width: 50%;
}

.case-core.cell3 .case-core-list {
  width: 33.33%;
}

.case-core-hover .case-core-list {
  padding-top: 62px;
  width: 20%;
}

.en .case-core-hover .case-core-list {
  padding-top: 20px;
}

.case-core-hover.cell2 .case-core-list {
  width: 33.3%;
}

.case-core-hover.cell3 .case-core-list {
  width: 25%;
}

.case-core-hover .case-core-list.current {
  width: 40%;
}

.case-core-hover.cell1 .case-core-list.current {
  width: 100%;
}

.case-core-hover.cell2 .case-core-list.current {
  width: 66.7%;
}

.case-core-hover.cell3 .case-core-list.current {
  width: 50%;
}

.case-core-list:last-of-type {
  border-right: none;
}

.case-core-list .case-logo {
  height: 58px;
  margin-bottom: 10px;
}

.case-core-list .case-title {
  font-size: 20px;
  line-height: 150%;
  margin-bottom: 10px;
  color: #fff;
}

.case-logo img {
  height: 100%;
  width: auto;
}

.case-summary h3 {
  font-size: 20px;
  color: #ffffff;
  line-height: 150%;
  margin-bottom: 15px;
}

.en .case-summary h3 {
  text-align: left;
}

.case-summary p {
  font-size: 14px;
  color: #ffffff;
  line-height: 150%;
  transition: all 0.5s;
  opacity: 0;
}

.case-core-list.current .case-summary p {
  opacity: 0.8;
}

.case-more-btn {
  height: 48px;
  width: 82px;
  /* background: rgba(0, 0, 0, 0.2) url(/sites/all/themes/yitu/images/more2.svg) */
  /* no-repeat center 18px; */
  border-radius: 24px;
  position: absolute;
  left: 35px;
  bottom: 70px;
  transition: all 0.5s;
  display: none;
}

.case-core-list.current .case-more-btn {
  opacity: 0;
}

.case-wrapper {
  padding: 80px 0;
  background: #fff;
}

.case-type {
  width: 140px;
  float: left;
}

.case-list {
  width: calc(100% - 140px);
  float: right;
}

.case-type .form-type-bef-link,
.case-type li {
  font-family: PingFangSC-Medium;
  color: #000000;
  width: 100%;
}

.case-type .form-type-bef-link a,
.case-type li a {
  color: #7f7f7f;
  padding: 12px 0 12px 24px;
  font-size: 18px;
  line-height: 150%;
  position: relative;
  width: 100%;
  display: block;
  transition: all 0.5s;
}

.case-type .form-type-bef-link a:before,
.case-type li a:before {
  position: absolute;
  content: '';
  display: block;
  width: 2px;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  background: #000;
  opacity: 0.1;
}

.case-type .form-type-bef-link a.active,
.case-type li.active a {
  color: #000;
}

.case-type .form-type-bef-link a.active:before,
.case-type li.active a:before {
  background-image: linear-gradient(-90deg, #6acaff 0%, #0b1cba 100%);
  opacity: 1;
}

.case-list ul {
  padding-left: 9px;
  margin-bottom: 0;
}

.case-list li {
  position: relative;
  width: 100%;
  background: #f4f5f9;
  padding: 60px;
  margin-bottom: 24px;
}

.case-list li h3 {
  font-size: 20px;
  color: #000000;
  margin-bottom: 20px;
}

.case-list li p {
  opacity: 0.7;
  font-size: 16px;
  color: #000000;
  line-height: 26px;
}

.case-list li span.type {
  display: block;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  font-size: 16px;
  line-height: 28px;
  position: absolute;
  left: -9px;
  top: 12px;
  border-width: 1px;
  border-style: solid;
  background-color: #fff;
}

.case-list li span.type:before {
  content: '';
  display: block;
  width: 10px;
  height: 6px;
  position: absolute;
  left: -1px;
  bottom: -7px;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 10px;
}

.case-list li span.type.yuanqu {
  color: #189583;
  border-color: rgba(24, 149, 131, 0.1);
}

.case-list li span.type.yuanqu:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yq.svg); */
}

.case-list li span.type.lingshou {
  color: #e07f16;
  border-color: rgba(224, 127, 22, 0.1);
}

.case-list li span.type.lingshou:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-ls.svg); */
}

.case-list li span.type.yiliao {
  color: #0060ff;
  border-color: rgba(0, 96, 255, 0.1);
}

.case-list li span.type.yiliao:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yl.svg); */
}

.case-list li span.type.anfang {
  color: #000aff;
  border-color: rgba(0, 10, 255, 0.1);
}

.case-list li span.type.anfang:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-af.svg); */
}

.case-list li span.type.jinrong {
  color: #a38f33;
  border-color: rgba(163, 143, 51, 0.1);
}

.case-list li span.type.jinrong:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-jr.svg); */
}

.case-list li span.type.aicity {
  color: #a95454;
  border-color: rgba(169, 84, 84, 0.1);
}

.case-list li span.type.aicity:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

.case-list li span.type.others {
  color: #e55354;
  border-color: rgba(69, 84, 184, 0.1);
}

.case-list li span.type.others:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

[class^='icon-'],
[class*=' icon-'] {
  font-family: icomoon;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  font-size: 100%;
  padding: 0;
  margin: 0;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: ' ';
  display: table;
}

.clearfix:after {
  clear: both;
}

a {
  color: #2fa0ec;
  text-decoration: none;
  outline: 0;
}

a:hover,
a:focus {
  color: #74777b;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.htmleaf-content {
  font-size: 150%;
  padding: 1em 0;
}

.htmleaf-content h2 {
  margin: 0 0 2em;
  opacity: 0.1;
}

.htmleaf-content p {
  margin: 1em 0;
  padding: 5em 0 0;
  font-size: 0.65em;
}

.bgcolor-1 {
  background: #f0efee;
}

.bgcolor-2 {
  background: #f9f9f9;
}

.bgcolor-3 {
  background: #e8e8e8;
}

.bgcolor-4 {
  background: #2f3238;
  color: #fff;
}

.bgcolor-5 {
  background: #df6659;
  color: #521e18;
}

.bgcolor-6 {
  background: #2fa8ec;
}

.bgcolor-7 {
  background: #d0d6d6;
}

.bgcolor-8 {
  background: #3d4444;
  color: #fff;
}

.bgcolor-9 {
  background: #ef3f52;
  color: #fff;
}

.bgcolor-10 {
  background: #64448f;
  color: #fff;
}

.bgcolor-11 {
  background: #3755ad;
  color: #fff;
}

.bgcolor-12 {
  background: #3498db;
  color: #fff;
}

.htmleaf-header {
  padding: 1em 190px;
  letter-spacing: -1px;
  text-align: center;
}

.htmleaf-header h1 {
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em;
  color: #c3c8cd;
}

.htmleaf-demo a {
  color: #1d7db1;
  text-decoration: none;
}

.htmleaf-demo {
  width: 100%;
  padding-bottom: 1.2em;
}

.htmleaf-demo a {
  display: inline-block;
  margin: 0.5em;
  padding: 0.6em 1em;
  border: 3px solid #1d7db1;
  font-weight: 700;
}

.htmleaf-demo a:hover {
  opacity: 0.6;
}

.htmleaf-demo a.current {
  background: #1d7db1;
  color: #fff;
}

.htmleaf-links {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: 1.5em;
  text-align: center;
}

.htmleaf-links::after {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #dbdbdb;
  content: '';
  -webkit-transform: rotate3d(0, 0, 1, 22.5deg);
  transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
  display: inline-block;
  margin: 0.5em;
  padding: 0;
  width: 1.5em;
  text-decoration: none;
}

.htmleaf-icon span {
  display: none;
}

.htmleaf-icon:before {
  margin: 0 5px;
  text-transform: none;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  font-family: icomoon;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
  width: 100%;
  padding-top: 10px;
}

.htmleaf-small {
  font-size: 0.8em;
}

.center {
  text-align: center;
}

.related {
  color: #fff;
  background: #333;
  text-align: center;
  font-size: 1.25em;
  padding: 0.5em 0;
  overflow: hidden;
}

.related > a {
  vertical-align: top;
  width: calc(100% - 20px);
  max-width: 340px;
  display: inline-block;
  text-align: center;
  margin: 20px 10px;
  padding: 25px;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
  display: inline-block;
  text-align: left;
  margin: 20px auto;
  padding: 10px 20px;
  opacity: 0.8;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
  opacity: 1;
}

.related a img {
  max-width: 100%;
  opacity: 0.8;
  border-radius: 4px;
}

.related a:hover img,
.related a:active img {
  opacity: 1;
}

.related h3 {
  font-family: microsoft yahei, sans-serif;
}

.related a h3 {
  font-weight: 300;
  margin-top: 0.15em;
  color: #fff;
}

.icon-htmleaf-home-outline:before {
  content: '\e5000';
}

.icon-htmleaf-arrow-forward-outline:before {
  content: '\e5001';
}

@media screen and (max-width: 50em) {
  .htmleaf-header {
    padding: 3em 10% 4em;
  }

  .htmleaf-header h1 {
    font-size: 2em;
  }
}

@media screen and (max-width: 40em) {
  .htmleaf-header h1 {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 30em) {
  .htmleaf-header h1 {
    font-size: 1.2em;
  }
}

.strips {
  min-height: 50vh;
  text-align: center;
  overflow: hidden;
  color: #fff;
  width: 100%;
  position: relative;
}

.strips__strip {
  will-change: width, left, z-index, height;
  position: absolute;
  width: 25%;
  min-height: 46vh;
  overflow: hidden;
  cursor: pointer;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip:nth-child(1) {
  left: 0;
}

.strips__strip:nth-child(2) {
  left: 15vw;
}

.strips__strip:nth-child(3) {
  left: 30vw;
}

.strips__strip:nth-child(4) {
  left: 45vw;
}

.strips__strip:nth-child(1) .strip__content {
  background: #244f75;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
  -webkit-animation-name: strip1;
  animation-name: strip1;
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.strips__strip:nth-child(2) .strip__content {
  background: #60bfbf;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip2;
  animation-name: strip2;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.strips__strip:nth-child(3) .strip__content {
  background: #8c4b7e;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  -webkit-animation-name: strip3;
  animation-name: strip3;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.strips__strip:nth-child(4) .strip__content {
  background: #f8bb44;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip4;
  animation-name: strip4;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

@media screen and (max-width: 760px) {
  .strips__strip {
    min-height: 12vh;
  }

  .strips__strip:nth-child(1) {
    top: 0;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(2) {
    top: 12vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(3) {
    top: 24vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(4) {
    top: 36vh;
    left: 0;
    width: 100%;
  }
}

.strips .strip__content {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.strips .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(3) translate(0, 0);
  -ms-transform: skew(-30deg) scale(3) translate(0, 0);
  transform: skew(-30deg) scale(3) translate(0, 0);
  opacity: 0.1;
}

.strips .strip__content:before {
  content: '';
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.05;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
  -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
  transform: skew(-30deg) scaleY(1) translate(0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.ai_office {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
}

.ai_office > img {
  width: 70px !important;
  height: 60px;
  margin-right: 20px;
}

.ai_office p:nth-child(2) {
  font-size: 16px !important;
  margin-bottom: 0;
  text-align: left;
}

.mainAi {
  display: flex;
  flex-wrap: wrap;
}

.ai_sec {
  width: 50%;
}

.ai_sec > p {
  font-size: 20px;
}

.strips .strip__inner-text {
  will-change: transform, opacity;
  position: absolute;
  z-index: 5;
  top: 50%;
  left: 50%;
  width: 70%;
  -webkit-transform: translate(-50%, -50%) scale(0.5);
  -ms-transform: translate(-50%, -50%) scale(0.5);
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip--expanded {
  width: 100%;
  top: 0 !important;
  left: 0 !important;
  z-index: 3;
  cursor: default;
}

@media screen and (max-width: 760px) {
  .strips__strip--expanded {
    min-height: 48vh;
  }
}

.strips__strip--expanded .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(1) translate(0, 0);
  -ms-transform: skew(-30deg) scale(1) translate(0, 0);
  transform: skew(-30deg) scale(1) translate(0, 0);
  opacity: 0.05;
}

.strips__strip--expanded .strip__title {
  opacity: 0;
}

.strips__strip--expanded .strip__inner-text {
  opacity: 1;
  -webkit-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}

.strips__strip--expanded .strip__inner-text p {
  font-size: 24px;
}

.strip__title {
  display: block;
  margin: 0;
  position: relative;
  z-index: 2;
  width: 100%;
  font-size: 40px;
  color: #fff;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

@media screen and (max-width: 760px) {
  .strip__title {
    font-size: 28px;
  }
}

.strip__close {
  position: absolute;
  right: 3vw;
  top: 3vw;
  opacity: 0;
  z-index: 10;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  -webkit-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.strip__close--show {
  opacity: 1;
  font-size: 30px;
}

.pw100 {
  width: 100%;
  margin-top: 10%;
}

@-webkit-keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.myBtn:active {
  background-color: unset !important;
  color: unset;
}
.myBtn:focus {
  outline: 0 !important;
}
#table {
  border: 1px solid #dee2e6;
  text-align: left;
}
#table1 {
  border: 1px solid #dee2e6;
  text-align: left;
}
#table2 {
  border: 1px solid #dee2e6;
  text-align: left;
}
#table3 {
  border: 1px solid #dee2e6;
  text-align: left;
}
#table4 {
  border: 1px solid #dee2e6;
  text-align: left;
}
.table th,
.table td {
  border-right: 1px solid #dee2e6;
}
.table thead th {
  border-bottom: 0 !important;
}
.tal {
  text-align: left;
}
.img100 {
  width: 100%;
}
.detail-p {
  padding-top: 20px;
  text-align: left;
  font-size: 14px;
  /* color: #999; */
}
a {
  color: unset;
}
.ptitle {
  width: 64px;
  height: 40px;
  line-height: 40px;
}
.ptitle {
  font-size: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
  /* background: rgba(255, 0, 0, .8); */
  color: #409eff;
}
.solutionDitails .block {
  width: 100%;
}
.solutionDitails .block img {
  width: 100%;
}
.solutionDitails .block h4 {
  font-size: 22px;
  /* // font-weight: ; */
}
.solutionDitails .block p {
  font-size: 16px;
  color: #999;
}
.pb0 {
  padding-bottom: 0;
}
.mypointer {
  cursor: pointer;
  overflow: hidden;
}
.mypointer h3 {
  transition: 0.4s;
}
.mypointer img {
  transition: 0.6s;
}
.mypointer:hover img {
  transform: scale(1.1);
}
.mypointer:before {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
  /* transition: opacity 5s cubic-bezier(.23,1,.32,1),height 5s cubic-bezier(.23,1,.32,1); */
  opacity: 0;
  transition: 0.6s;
  background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));
}
.mypointer:hover:before {
  opacity: 1;
}
.mypointer:hover h3 {
  transform: translateY(-30px);
}
.pb130 {
  padding-bottom: 130px;
}
.pb0 {
  padding-bottom: 0;
}
.topChange {
  display: flex;
  width: 375px;
  margin: 0 auto;
  position: absolute;
  top: -66px;
  left: 50%;
  transform: translate(-50%, 0);
  height: 66px;
  line-height: 66px;
}
.topChange li {
  padding: 0 20px;
  font-size: 20px;
  color: white;
  cursor: pointer;
}
.topChange li.active {
  background: white;
  color: #0067ed;
}
.img-block {
  width: 85%;
}
.advantage-show {
  height: 480px;
  background: url(../../public/img/Solution/line_dot-3f88c.png) no-repeat 50%;
  background-size: contain;
  position: relative;
  transition: all 0.3s;
}
.aos-animate {
  opacity: 1;
  transform: scale(1);
}
.advantage-box {
  height: 170px;
  background: #fff;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 20px;
  transition: all 0.5s;
}
.advantage-show li p {
  background: #fff;
  padding: 8px 20px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%) scale(0);
  margin: 0;
  white-space: nowrap;
  border-radius: 4px;
  box-shadow: 0 0 15px 0 rgba(5, 5, 5, 0.3);
  font-size: 14px;
  transition: all 0.5s;
}
.advantage-show li span {
  position: absolute;
  left: -14px;
  top: -14px;
  display: block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 20px;
  text-align: center;
  /* //   background: #0067ed; */
  color: #fff;
  border-radius: 100%;
}

.advantage-show li {
  position: absolute;
  border-radius: 100%;
  display: block;
  background: #000;
  transition: all 0.5s;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  box-shadow: 0 5px 32px 0 hsla(0, 0%, 53.3%, 0.24);
}
.advantage-show li p.aos-animate {
  transform: translateX(-50%) scale(1);
}

.advantage-show .one {
  width: 210px;
  height: 210px;
  left: 40%;
  top: 30%;
}
.advantage-show .two {
  width: 150px;
  height: 150px;
  left: 15%;
  top: 25%;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.advantage-show .three {
  width: 135px;
  height: 135px;
  right: 16%;
  top: 5%;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.advantage-show .four {
  width: 120px;
  height: 120px;
  left: 19%;
  bottom: 10%;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.advantage-show .five {
  width: 100px;
  height: 100px;
  right: 10%;
  bottom: 20%;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}
.advantage-show .six {
  width: 70px;
  height: 70px;
  left: 40%;
  top: 15%;
  -webkit-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.advantage-show .seven {
  width: 60px;
  height: 60px;
  right: 13%;
  top: 40%;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.advantage-show .eight {
  width: 40px;
  height: 40px;
  right: 30%;
  bottom: 7%;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.advantage-show .one p {
  font-size: 18px;
}
.upDown {
  -webkit-animation-name: upDown;
  animation-name: upDown;
  -webkit-animation-duration: 5s;
  animation-duration: 5s;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.f70 {
  display: inline-block;
  color: #0067ed;
  line-height: 1;
  margin: 40px 0 20px;
  font-size: 60px;
}
.p16 {
  font-size: 16px;
  font-weight: 300;
}
@media screen and (max-width: 480px) {
  .advantage-show .one {
    width: 10.5rem;
    height: 10.5rem;
    left: 26%;
    top: 33%;
  }
  .advantage-show .two {
    width: 6.6rem;
    height: 6.6rem;
    left: 9%;
    top: 11%;
  }
  .advantage-show .three {
    width: 5.3rem;
    height: 5.3rem;
    right: 12%;
    top: 15%;
  }
  .advantage-show .four {
    width: 7rem;
    height: 7rem;
    left: 14%;
    bottom: 1%;
  }
  .advantage-show .five {
    width: 5.8rem;
    height: 5.8rem;
    right: 3%;
    bottom: 17%;
  }
  .advantage-show .six {
    width: 70px;
    height: 70px;
    left: 40%;
    top: 15%;
    -webkit-animation-delay: 0.8s;
    animation-delay: 0.8s;
  }
  .advantage-show .seven {
    width: 60px;
    height: 60px;
    right: 13%;
    top: 40%;
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
  .advantage-show .eight {
    width: 40px;
    height: 40px;
    right: 30%;
    bottom: 7%;
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }
  .txtbox {
    padding: 20px 20px;
  }
  .img-block {
    width: 100%;
  }
}
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0s;
}
.plus-icon-leave-to {
  opacity: 0;
}
p {
  margin-bottom: 11px;
}
.poL {
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 10px;
  text-align: left;
  color: white;
}
.poL h3 {
  margin-bottom: 20px;
  font-size: 24px;
  color: white;
}
.poR {
  position: absolute;
  width: 100%;
  bottom: 0px;
  left: 10px;
  text-align: left;
  color: white;
}
.poR h3 {
  margin-bottom: 20px;
  font-size: 24px;
  color: white;
}
.poA {
  position: absolute;
  top: 235px;
  left: 260px;
  text-align: left;
  /* background: white; */
  color: white;
}
.poA h3 {
  font-size: 30px;
  margin-bottom: 1rem;
  color: white;
}
.poA p {
  font-size: 22px;
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.ai-advantage {
    text-align: left;
}
</style>
